import { NotificationChannel, UserNotifications } from "@ews/react-data";
import SettingsTitle from "../../../../../Settings/SettingsTitle/SettingsTitle";
import SettingsCheckbox from "../../../../../Settings/SettingsComponents/SettingsCeckbox/SettingsCeckbox";



export const EntityNotificationSetting: React.FC<{ userNotification: UserNotifications; onUpdate: (data: Partial<UserNotifications>) => void; }> = ({ userNotification, onUpdate }) =>
{

    const isChecked = (value: NotificationChannel = NotificationChannel.NONE,) =>
    {
        return (value & NotificationChannel.EMAIL) !== NotificationChannel.NONE;
    };

    return <>
        <SettingsTitle text={"COM_FACPMANAGEMENT_USER_ACCOUNT_NOTIFICATIONS_MAILS"} ></SettingsTitle>

        <SettingsCheckbox
            checked={isChecked(userNotification.statusNewCustomer)}
            text={"COM_BANNERS_NEW_CLIENT"}
            onChange={(checked) =>
            {
                const statusNewCustomer = checked ? NotificationChannel.EMAIL : NotificationChannel.NONE;
                onUpdate({ statusNewCustomer });
            }} />

        <SettingsCheckbox
            checked={isChecked(userNotification.statusNewUser)}
            text={"COM_FACPMANAGEMENT_USERS_ADD_NEW"}
            onChange={(checked) =>
            {
                const statusNewUser = checked ? NotificationChannel.EMAIL : NotificationChannel.NONE;
                onUpdate({ statusNewUser });
            }} />

        <SettingsCheckbox
            checked={isChecked(userNotification.statusNewSystem)}
            text={"COM_FACPMANAGEMENT_FACPS_ADD_NEW"}
            onChange={(checked) =>
            {
                const statusNewSystem = checked ? NotificationChannel.EMAIL : NotificationChannel.NONE;
                onUpdate({ statusNewSystem });
            }} />

        <SettingsCheckbox
            checked={isChecked(userNotification.statusNewShare)}
            text={"COM_FACPMANAGEMENT_SHARE_HEADLINE_INVITE"}
            onChange={(checked) =>
            {
                const statusNewShare = checked ? NotificationChannel.EMAIL : NotificationChannel.NONE;
                onUpdate({ statusNewShare });
            }} />
    </>;
};
